module.exports = __webpack_public_path__ + "static/media/Michael-Barry-VPMA-Headshot.8638be86.png";